/* Quantity popover interactions — reused by cart and product pages */
(function () {
  function initQuantityPopovers() {
    var popovers = document.querySelectorAll('quantity-popover');
    if (!popovers.length) return;

    popovers.forEach(function (popover) {
      var button = popover.querySelector('[data-quantity-popover-toggle]');
      var content = popover.querySelector('[data-quantity-popover-content]');
      if (!button || !content) return;

      button.addEventListener('click', function (e) {
        e.preventDefault();
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !expanded);
        content.hidden = expanded;
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (!popover.contains(e.target)) {
          button.setAttribute('aria-expanded', 'false');
          content.hidden = true;
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    initQuantityPopovers();
  } else {
    document.addEventListener('DOMContentLoaded', initQuantityPopovers);
  }
})();